<div class="page-title">
    <div class="row">
        <div class="col-md-12">
            <div class="col-md-6">
                <label class="general-label-14"><b>DETALLE ARTÍCULO</b> </label>
              </div>
              <div class="col-md-6">
                <button  *ngIf="data.promocion" class="cuadro-promo" (click)="openSliderPromotions(data.banner)">
                    <div>
                      PROMO
                    </div>
                </button>
                <a mat-dialog-close class="pull-right"><i class="fa fa-close"></i></a>
                <!-- <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Install</button> -->
            </div>
        </div>
  
    </div>
  </div>
<mat-dialog-content class="mat-typography">
        <div class="col-md-12">
            <div class="col-md-6">
                <label *ngIf="data.clave" class="general-label-14"><b>Producto:</b> {{ data.clave }}</label>
              </div>
              <div class="col-md-6">
                <label *ngIf="data.clasificacion" class="general-label-14"><b>Clasificación:</b> {{ data.clasificacion }}</label>
            </div>
        </div>
        <div class="col-md-12">
            <div class="col-md-6">
                <label *ngIf="data.ClaveProveedor" class="general-label-14"><b>Clave de proveedor:</b> {{ data.ClaveProveedor }}</label>
              </div>
            <div class="col-md-6">
                <label *ngIf="data.descripcion" class="general-label-14"><b>Descripción del producto:</b> {{ data.descripcion }}</label>
              </div>
        </div>
        <div class="col-md-12">
            <div class="col-md-6">
                <label *ngIf="data.CategoriaProducto" class="general-label-14"><b>Línea:</b> {{ data.CategoriaProducto }} </label>
            </div>
            <div class="col-md-6">
                <p *ngIf="data.descripcion_2" class="general-label-14"><b>Terminología:</b> {{ data.descripcion_2 }} </p>
            </div>
        </div>

        <div class="col-md-12">
            <div class="col-md-6">
                <label *ngIf="data.descripcion_3" class="general-label-14"><b>Detalle:</b> {{ data.descripcion_3 }} </label>
            </div>
            <div class="col-md-6">
                <label *ngIf="data.producto" class="general-label-14"><b>Subcategoría:</b> {{ data.producto }} </label>
            </div>
        </div>
       
            <div class="col-md-12">
                <div class="col-md-6">
                    <label *ngIf="data.marca" class="general-label-14"><b>Marca:</b> {{ data.marca }}</label>
                </div>
                <!-- <div *ngIf="!data.measurement_units" class="col-md-6">
                    <label class="col-md-3 general-label-14"><b>U.M. de ventas:</b></label>
                    <mat-select *ngIf="data.unidad_medida_clave" class="col-md-2" [(value)]="data.unidad_medida_clave" [disabled]="true">
                        <mat-option value="{{ unidad.IDUnidadMedida }}" *ngFor="let unidad of data.measurement_units">{{ unidad.UnidadMedida }}</mat-option>
                    </mat-select> 
                </div> -->
                <!-- *ngIf="data.measurement_units" -->
                <div  class="col-md-6">
                    <label class="general-label-14"><b>U.M. de ventas:</b>  {{ data.UnidadMedida }}</label>
                </div>
            </div>
       
        <div class="col-md-12">
            
              <div class="col-md-6">
                <label *ngIf="data.existencia" class="general-label-14"><b>Existencias:</b> {{ data.existencia }} </label>
            </div>
            <div class="col-md-6">
                <label *ngIf="data.precio" class="general-label-14"><b>Precio:</b> {{ data.precio | number : '1.2-2' }} </label>
                
            </div>
        </div>
        <div class="col-md-12">
            <div class="col-md-6">
                <label *ngIf="data.familia" class="general-label-14"><b>Terminología:</b> {{ data.familia }}</label>
              </div>
              <div class="col-md-6">
                <label *ngIf="data.request_amount" class="general-label-14"><b>Cantidad a solicitar:</b> {{ data.request_amount }} </label>
            </div>
        </div>
        <div class="col-md-12">
            <div class="col-md-6">
                <label class="general-label-14"><b>Armadora:</b> {{data.armadora}} </label>
            </div>
            <div class="col-md-6">
                <label *ngIf="data.status_amount" class="general-label-14"><b>Disponible ATP:</b> <button class="btn-{{data.status_amount}}" type="button"><i class="fa fa-circle"></i></button></label>
            </div>
        </div>
   
    <hr class="short alt">
    <br>
    <div class="col-md-12">
        <div *ngIf="data.images" class="col-md-6">
            <label class="general-label-14"><b>Imágenes del producto</b> </label>
            <div *ngFor="let img of data.images; let i = index">
                <a href="{{ img.urlimg }}" target="_blank">Imágen {{i + 1}}</a><br>
            </div> 
        </div>
        <div *ngIf="data.standard_price" class="col-md-6 gen-border">
            <label class="general-label-14"><b>Determinación de precio</b> </label>
            <div>
                <label  class="general-label-14">Precio unitario: {{ data.precio | number : '1.2-2' }}</label><br>
                <label class="general-label-14">Descuento estandar: {{ data.standard_discount | number : '1.0-0' }} %</label><br>
                <label class="general-label-14">Descuento comercial: {{ data.comercial_discount | number : '1.0-0' }} %</label><br>
                <label class="general-label-14">Descuento PP: {{ data.PP }} %</label><br>
                <label class="general-label-14">Precio unitario - Descuento estandar: {{ data.price_disc_standar | number : '1.2-2' }} </label><br>
                <label class="general-label-14">Precio unitario - Descuento comercial: {{ data.price_disc_comer | number : '1.2-2' }}</label><br>
                <label class="general-label-14">Importe: ---</label><br>
                <label class="general-label-14">Importe con impuesto seguro: ---</label>
            </div>
        </div>
    </div>
    <br>
    <div *ngIf="data.equivalences" class="col-md-12 gen-border">
        <label class="general-label-14"><b>Equivalencias</b> </label>
        <!-- <label *ngIf="data.equivalences.length == 0"class="general-label">Sin equivalencias</label> -->
        <table class="table table-hover mbn" id="equivalences-index">
            <thead>
                <tr class="active">
                  <th>Producto</th>
                  <th>Terminología</th>
                  <th>Descripción del producto</th>
                  <th placement="top" ngbTooltip="Unidad de medida de venta">U.M.V.</th>
                  <th>Marca</th>
                  <th>Clasificación</th>
                  <!-- <th>Clase</th>
                  <th>Departamento</th> -->
                  <th>Precio Unitario</th>
                </tr>
              </thead>
            <tbody>
              <tr *ngFor="let column of data.equivalences; let i = index" id="tr_equi_{{column.clave}}">
                <td><a (click)="get_product_detail(column.clave, 1, -1, true)"> {{ column.clave }}</a></td>
                <!-- <td>{{ column.clave }}</td> -->
                <td>{{ column.descripcion_2 }}</td>
                <td>{{ column.descripcion }}</td>
                <td>{{ column.UnidadMedida }}</td>
                <td>{{ column.marca }}</td>
                <td>{{ column.clasificacion }}</td>
                <!-- <td>{{ column.CategoriaProducto }}</td> -->
                <td>{{ column.precio | number : '1.2-2' }}</td>
              </tr>       
            </tbody>
          </table>
    </div>
      
        
     
</mat-dialog-content>



<!-- Copyright 2021 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->